import {
  ARC_BACKGROUND_COLOR,
  ARC_END_ANGLE,
  ARC_START_ANGLE,
} from '../constants.js';
import { useGaugeChartAspectRatio } from '../hooks/useGaugeChartAspectRatio.js';
import { buildArc } from '../utils/build-arc.js';

export const GaugeBaseArc = () => {
  const { arcOuterRadius, arcInnerRadius } = useGaugeChartAspectRatio();

  const gaugeBaseD = buildArc(
    arcInnerRadius,
    arcOuterRadius,
    ARC_START_ANGLE,
    ARC_END_ANGLE,
  );

  return <path d={gaugeBaseD} fill={ARC_BACKGROUND_COLOR} />;
};
